export let Hostname;

(function (Hostname) {
  Hostname["At"] = "vinted.at";
  Hostname["AtSandbox"] = "sandbox-at.vinted.net";
  Hostname["Be"] = "vinted.be";
  Hostname["BeSandbox"] = "sandbox-be.vinted.net";
  Hostname["Cz"] = "vinted.cz";
  Hostname["OldCz"] = "old.vinted.cz";
  Hostname["CzSandbox"] = "sandbox-cz.vinted.net";
  Hostname["OldCzSandbox"] = "sandbox-cz-old.vinted.net";
  Hostname["De"] = "vinted.de";
  Hostname["OldDe"] = "kleiderkreisel.de";
  Hostname["DeSandbox"] = "sandbox-de.vinted.net";
  Hostname["OldDeBabies"] = "mamikreisel.de";
  Hostname["OldDeBabiesSandbox"] = "sandbox-de-babies.vinted.net";
  Hostname["Es"] = "vinted.es";
  Hostname["OldEs"] = "local.vinted.es";
  Hostname["EsSandbox"] = "sandbox-es.vinted.net";
  Hostname["OldEsSandbox"] = "sandbox-es-local.vinted.net";
  Hostname["Fr"] = "vinted.fr";
  Hostname["FrSandbox"] = "sandbox-fr.vinted.net";
  Hostname["Hu"] = "vinted.hu";
  Hostname["HuSandbox"] = "sandbox-hu.vinted.net";
  Hostname["Lt"] = "vinted.lt";
  Hostname["LtSandbox"] = "sandbox-new-lt.vinted.net";
  Hostname["Lu"] = "vinted.lu";
  Hostname["LuSandbox"] = "sandbox-lu.vinted.net";
  Hostname["Nl"] = "vinted.nl";
  Hostname["OldNl"] = "local.vinted.nl";
  Hostname["NlSandbox"] = "sandbox-nl.vinted.net";
  Hostname["OldNlSandbox"] = "sandbox-nl-local.vinted.net";
  Hostname["Pl"] = "vinted.pl";
  Hostname["OldPl"] = "old.vinted.pl";
  Hostname["PlSandbox"] = "sandbox-pl.vinted.net";
  Hostname["OldPlSandbox"] = "sandbox-pl-old.vinted.net";
  Hostname["Se"] = "vinted.se";
  Hostname["SeSandbox"] = "sandbox-se.vinted.net";
  Hostname["Sk"] = "vinted.sk";
  Hostname["SkSandbox"] = "sandbox-sk.vinted.net";
  Hostname["Pt"] = "vinted.pt";
  Hostname["PtSandbox"] = "sandbox-pt.vinted.net";
  Hostname["Uk"] = "vinted.co.uk";
  Hostname["OldUk"] = "old.vinted.co.uk";
  Hostname["UkSandbox"] = "sandbox-uk.vinted.net";
  Hostname["OldUkSandbox"] = "sandbox-uk-old.vinted.net";
  Hostname["Us"] = "vinted.com";
  Hostname["OldUs"] = "old.vinted.com";
  Hostname["UsSandbox"] = "sandbox-us.vinted.net";
  Hostname["OldUsSandbox"] = "sandbox-us-old.vinted.net";
  Hostname["It"] = "vinted.it";
  Hostname["ItSandbox"] = "sandbox-it.vinted.net";
  Hostname["Ro"] = "vinted.ro";
  Hostname["RoSandbox"] = "sandbox-ro.vinted.net";
  Hostname["Dk"] = "vinted.dk";
  Hostname["DkSandbox"] = "sandbox-dk.vinted.net";
  Hostname["Fi"] = "vinted.fi";
  Hostname["FiSandbox"] = "sandbox-fi.vinted.net";
})(Hostname || (Hostname = {}));

export const OLD_HOST_REDIRECTS = {
  [Hostname.OldCz]: Hostname.Cz,
  [Hostname.OldCzSandbox]: Hostname.CzSandbox,
  [Hostname.OldDe]: Hostname.De,
  [Hostname.OldDeBabies]: Hostname.De,
  [Hostname.OldDeBabiesSandbox]: Hostname.DeSandbox,
  [Hostname.OldEs]: Hostname.Es,
  [Hostname.OldEsSandbox]: Hostname.EsSandbox,
  [Hostname.OldNl]: Hostname.Nl,
  [Hostname.OldNlSandbox]: Hostname.NlSandbox,
  [Hostname.OldPl]: Hostname.Pl,
  [Hostname.OldPlSandbox]: Hostname.PlSandbox,
  [Hostname.OldUk]: Hostname.Uk,
  [Hostname.OldUkSandbox]: Hostname.UkSandbox,
  [Hostname.OldUs]: Hostname.Us,
  [Hostname.OldUsSandbox]: Hostname.UsSandbox
}; // Please keep in sync with config/constants/hostnames.rb

export const DOMAIN_ALIASES = {
  sandbox: {
    'fr-FR': Hostname.FrSandbox,
    'es-ES': Hostname.EsSandbox,
    'fr-BE': Hostname.BeSandbox,
    'fr-LU': Hostname.LuSandbox,
    'nl-NL': Hostname.NlSandbox,
    'lt-LT': Hostname.LtSandbox,
    'de-DE': Hostname.DeSandbox,
    'de-AT': Hostname.AtSandbox,
    'it-IT': Hostname.ItSandbox,
    'en-GB': Hostname.UkSandbox,
    'pt-PT': Hostname.PtSandbox,
    'en-US': Hostname.UsSandbox,
    'cs-CZ': Hostname.CzSandbox,
    'sk-SK': Hostname.SkSandbox,
    'pl-PL': Hostname.PlSandbox,
    'sv-SE': Hostname.SeSandbox,
    'hu-HU': Hostname.HuSandbox,
    'ro-RO': Hostname.RoSandbox,
    'da-DK': Hostname.DkSandbox,
    'fi-FI': Hostname.FiSandbox
  },
  production: {
    'fr-FR': Hostname.Fr,
    'es-ES': Hostname.Es,
    'fr-BE': Hostname.Be,
    'fr-LU': Hostname.Lu,
    'nl-NL': Hostname.Nl,
    'lt-LT': Hostname.Lt,
    'de-DE': Hostname.De,
    'de-AT': Hostname.At,
    'it-IT': Hostname.It,
    'en-GB': Hostname.Uk,
    'pt-PT': Hostname.Pt,
    'en-US': Hostname.Us,
    'cs-CZ': Hostname.Cz,
    'sk-SK': Hostname.Sk,
    'pl-PL': Hostname.Pl,
    'sv-SE': Hostname.Se,
    'hu-HU': Hostname.Hu,
    'ro-RO': Hostname.Ro,
    'da-DK': Hostname.Dk,
    'fi-FI': Hostname.Fi
  }
};